import { marketplaceBadgeColors } from "@/lib/orderUtils";

/**
 * Badge visual com o nome do marketplace de origem (Shopee, ML, etc).
 * Só renderiza quando o pedido tem marketplace identificado.
 *
 * Props:
 *   - marketplace: string ("Shopee", "Mercado Livre", etc.)
 *   - size: "sm" (padrão) | "md" | "lg"
 *   - className: classes extras
 */
export default function MarketplaceBadge({ marketplace, size = "sm", className = "" }) {
  if (!marketplace) return null;
  const { bg, fg } = marketplaceBadgeColors(marketplace);
  const sizeClass = {
    sm: "text-[10px] px-2 py-0.5",
    md: "text-xs px-2.5 py-1",
    lg: "text-sm px-3 py-1.5",
  }[size] || "text-[10px] px-2 py-0.5";
  return (
    <span
      className={`font-bold uppercase tracking-widest ${sizeClass} ${className}`}
      style={{ backgroundColor: bg, color: fg }}
      data-testid={`marketplace-badge-${marketplace.toLowerCase().replace(/\s+/g, "-")}`}
    >
      {marketplace}
    </span>
  );
}
